import { render, staticRenderFns } from "./AudioWidget.vue?vue&type=template&id=73afad8e&scoped=true"
import script from "./AudioWidget.vue?vue&type=script&lang=js"
export * from "./AudioWidget.vue?vue&type=script&lang=js"
import style0 from "./AudioWidget.vue?vue&type=style&index=0&id=73afad8e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73afad8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73afad8e')) {
      api.createRecord('73afad8e', component.options)
    } else {
      api.reload('73afad8e', component.options)
    }
    module.hot.accept("./AudioWidget.vue?vue&type=template&id=73afad8e&scoped=true", function () {
      api.rerender('73afad8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/playerWidgets/AudioWidget.vue"
export default component.exports